import "core-js/modules/es.object.assign.js";
import { Modals } from "../../Types/Modals";
import { reactive, computed, toRefs } from "vue";
//@ts-ignore
import { useModalStore } from "@store/ModalStore";
export function useContactAgencyModal() {
  var state = reactive({
    agencyModalData: null,
    reopenAfterLogin: false,
    successModalDataEmitted: {}
  });
  //Injecting the store
  var modalStore = useModalStore();
  var amdLabels = computed(() => window["contactAgencyModalData"].labels);
  var amdIcons = computed(() => window["contactAgencyModalData"].icons);
  var wikicasaUrl = computed(() => window["wikicasaNewsURL"]);
  var listingType = computed(() => window["_listingType"]);
  var openContactModal = function openContactModal(agencyData) {
    var isContactModal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    agencyData.wikicasaNewsUrl = wikicasaUrl.value;
    state.agencyModalData = agencyData;
    if (isContactModal) modalStore.setShowModal(Modals.contactModal);
  };
  var openAndReturnToCAMS = function openAndReturnToCAMS(toModal) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    modalStore.openAndReturnTo({
      fromModal: Modals.contactModal,
      toModal,
      payload
    });
    state.reopenAfterLogin = true;
  };
  return Object.assign(Object.assign({}, toRefs(state)), {
    amdLabels,
    amdIcons,
    listingType,
    openContactModal,
    openAndReturnToCAMS
  });
}